import { useGetIdentity } from "@refinedev/core";
import { Navigate, Outlet } from "react-router";
import type { UserInfo } from "../types/auth";
import { AUDITOR_USER_TYPES } from "../types/auth";
import { LoadingSpinner } from "./common/LoadingSpinner";

/**
 * Route guard for the `/auditor/*` section.
 * Allows user_type 4 (Auditor Manager) and 5 (Auditor); redirects everyone
 * else to the home page.
 */
export const AuditorRoute = () => {
  const { data: identity, isLoading } = useGetIdentity<UserInfo>();

  if (isLoading) {
    return <LoadingSpinner fullScreen tip="Checking permissions..." />;
  }

  const userType = identity?.app_user?.user_type;
  const isAuditor =
    userType !== undefined &&
    (AUDITOR_USER_TYPES as readonly number[]).includes(userType);

  if (!isAuditor) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};
